import React, { useEffect, useState } from 'react'
import { addFlashMessage } from '../../../actions'
import { getCheckInAppointment, getGuardSpecialities, getWaitingTimes, recoverOldAppointmentData } from '../../../api'
import Clinic from './Clinic'
import Speciality from './Speciality'
import to from 'await-catch'
import moment from 'moment'
import { connect } from 'react-redux'

let inFlightGuardSpecialitiesRequest = null

const FormER = ({ setSubmitedTurn, submitedTurn, showLoader, hideLoader, clear, patient, auth, dispatch }) => {
    const [specialities, setSpecialities] = useState([]);
    const [clinics, setClinics] = useState([]);

    useEffect(() => {
        let isMounted = true

        const fetchData = async () => {
            try {
                showLoader()

                if (!inFlightGuardSpecialitiesRequest) {
                    inFlightGuardSpecialitiesRequest = to([getGuardSpecialities()]).finally(() => {
                        inFlightGuardSpecialitiesRequest = null
                    })
                }

                const [err, [{ data: specsData } = {}]] = await inFlightGuardSpecialitiesRequest

                if (err)
                    throw new Error("Error en el fetch de especialidades");

                if (!isMounted) return

                setSpecialities(specsData);
            } catch (error) {
                if (!isMounted) return
                dispatch(addFlashMessage("Ocurrió un error cargando las especialidades"));
            }
            finally {
                if (!isMounted) return
                hideLoader()
            }
        };

        fetchData();

        return () => {
            isMounted = false
        }
    }, []);

    const saveSpeciality = (speciality) => {
        setSubmitedTurn({ ...submitedTurn, speciality: speciality });
    }

    const saveClinic = async (clinic) => {
        await obtainTurn(clinic);
    }

    const obtainTurn = async (clinic) => {
        try {
            showLoader();

            const params = {
                clinica: clinic.id,
                especialidad: submitedTurn.speciality.id,
                fecha: moment().add(Number(clinic.waitTime), 'minutes').format('DD/MM/YYYY HH:mm'),
                nroDoc: patient.numeroDocumento,
                email: auth.email
            }

            const [err, { data } = {}] = await to(getCheckInAppointment(params))

            if(err)
                throw new Error("Error al obtener turno");

            if (!err) {
                if (!data.nuevo) {
                    const [err, { data: oldApp } = {}] = await to(
                        recoverOldAppointmentData({
                            clinic: clinic.id,
                            appointment: data.turno
                        })
                    )
                    if (!err) {
                        clinic.waitingTime = moment(oldApp.fechaTurnoDateTime)
                    }
                }
                setSubmitedTurn({ ...submitedTurn, clinic: clinic, turno: data.turno });
            }

            setSubmitedTurn(prev => ({
                ...prev,
                clinic: clinic,
                isSubmited: true
            }));

        } catch (error) {
            console.error(error);
            clear();
        } finally {
            hideLoader();
        }
    };

    useEffect(() => {
        const fetchClinics = async () => {
            try {
                showLoader()
                const [err, { data } = {}] = await to(getWaitingTimes(submitedTurn.speciality.id));

                if (err)
                    throw new Error("Error en el fetch de clinicas");

                setClinics(data);
            } catch (error) {
                dispatch(addFlashMessage("Ocurrió un error cargando los turnos"));
            }
            finally {
                hideLoader()
            }
        }
        if (submitedTurn.speciality !== null) {
            fetchClinics();
        }
    }, [submitedTurn.speciality]);

    return (
        <>
            {
                submitedTurn.speciality === null ?
                    <Speciality saveSpeciality={saveSpeciality} specialities={specialities} />
                    :
                    <Clinic saveClinic={saveClinic} clinics={clinics} clear={clear} />
            }
        </>
    )
}

const mapStateToProps = ({ patient, auth }) => {
    return { patient, auth }
}


export default connect(mapStateToProps)(FormER)
